import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import error404 from "../assets/error-404.jpg";

const Error404 = () => (
  <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#edf3f7", padding: 24 }}>
    <Helmet>
      <title>SAT KARTAR HOSPITAL :: 404</title>
    </Helmet>
    <Link to="/dashboard" style={{ display: "block", maxWidth: 720, width: "100%" }}>
      <img src={error404} alt="Page not found" style={{ width: "100%", borderRadius: 18, boxShadow: "0 18px 45px rgba(15,23,42,.16)" }} />
    </Link>
  </div>
);

export default Error404;
